









































































































import { Vue, Component } from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider } from 'vee-validate-3';

import InternationalizationService from '@/api/InternationalizationService';

import CloseModalIcon from '@/components/icons/CloseModal.vue';
import CoinIcon from '@/components/icons/WidgetCoin.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import ModalOptions from '@/components/Modal/ModalOptions';
import CountrySelect from '@/componentsV2/molecules/CountrySelect/CountrySelect.vue';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';

import { setSessionSignup } from '@/views/Signup/session';

import {
  ECountries,
  EInternationalizationStatus,
  EUnavailableStatus
} from '@/models/internationalization';
import { IBusinessType } from '@/models/business';

import eventBus from '@/utils/eventBus';
import { scrollToTop } from '@/utils/scrollToTop';

import { isExternalOauthSessionOnline } from '@/router/router-utils';

import { OnlineOnboardingURL } from '@/views/Onboarding/helpers';
import PhoneInput from '@/components/molecules/PhoneInput/PhoneInput.vue';
import Input from '@/componentsV2/molecules/Inputs/TextField.vue';

import Categories from '@/components/organisms/Categories/Categories.vue';
import SignUpService from '@/api/SingupService';
import InputWrapper from '@/componentsV2/molecules/Inputs/InputWrapper.vue';
import APIService from '@/api';
import BusinessOnboardingModel from '../../BusinessOnboardingModel.vue';

type BusinessDetailsFormData = {
  businessName: string;
  website: string;
  phone: {
    code: string;
    iso: string;
    number: string;
  };
  country: any;
  category: {
    id: string;
    otherValue: string;
  };
};

interface ICategory {
  name: string;
  id: string;
}

@Component({
  components: {
    ValidationObserver,
    ValidationProvider,
    CountrySelect,
    FilledButton,
    CloseModalIcon,
    Typography,
    CoinIcon,
    PhoneInput,
    Categories,
    Input,
    InputWrapper
  }
})
export default class YourStore extends BusinessOnboardingModel {
  internationalizationService = new InternationalizationService();
  signUpService = new SignUpService();

  errors: string[] = [];
  categories: any[] = this.filledCategories;

  countryPhone = {};

  formData: BusinessDetailsFormData = {
    businessName: this.yourStoreDetailsFormData.businessName || '',
    website: this.yourStoreDetailsFormData.website || '',
    phone: this.yourStoreDetailsFormData.phone || {
      code: this.yourStoreFormData.phoneCode,
      iso: this.yourStoreFormData.countryIso2,
      number: ''
    },
    country: this.yourStoreFormData.country,
    category: this.businessCategoryForm.selectedCategory || {
      id: '',
      otherValue: ''
    }
  };

  loading = false;

  $refs!: {
    observer: InstanceType<typeof ValidationObserver>;
  };

  get flags() {
    return this.$store.getters['flags/getFlags'];
  }

  get businessCategoryForm() {
    return this.$store.getters[
      'businessOnboarding/getYourBusinessCategoryForm'
    ];
  }

  get otherCategory() {
    const category = this.categories.find(categ => categ.label === 'Other');

    if (!category) return {};

    return category;
  }

  get hasOtherError() {
    return (
      this.otherCategory &&
      this.otherCategory.value === this.formData.category.id &&
      !this.formData.category.otherValue
    );
  }

  get yourStoreFormData() {
    return this.$store.getters['businessOnboarding/getYourStoreForm'];
  }

  get yourStoreDetailsFormData() {
    return this.$store.getters['businessOnboarding/getStoreDetailsForm'];
  }

  get filledCategories() {
    return this.$store.getters['businessOnboarding/getCategories'] || [];
  }

  get shouldNotify() {
    return this.formData.country.status === EInternationalizationStatus.UNDATED;
  }

  get hasSelectedCountry() {
    return !!Object.values(this.formData.country).length;
  }

  get isValidCategory() {
    return Boolean(this.formData.category.id);
  }

  get isOnlineSignup() {
    return isExternalOauthSessionOnline();
  }

  toggleCategory(categoryId: string) {
    const category = this.categories.find(
      category => category.value === categoryId
    );

    if (!category) return;

    if (category.label !== 'Other') {
      this.formData.category.otherValue = '';
    }

    this.formData.category.id = categoryId;
  }

  setCountryOnSignUpSession() {
    const country = this.formData.country;

    const isPopularCountry = !Object.values(EUnavailableStatus).includes(
      country.status as EUnavailableStatus
    );

    if (isPopularCountry) {
      setSessionSignup({
        country: country.name as ECountries,
        countryIso2: country.countryIso2
      });
    }
  }

  handleChangeOtherInput(value: string) {
    this.formData.category.otherValue = value;
  }

  async onSubmit() {
    const formRef = this.$refs.observer;
    const formIsValid = await formRef.validate();

    if (!formIsValid) {
      this.$notification(
        String(this.$t('common.alerts.highlightedItemsError')),
        'error'
      );

      return;
    }

    if (!this.isValidCategory) {
      this.$notification('Please select a category', 'error');

      return;
    }

    try {
      this.loading = true;

      this.setCountryOnSignUpSession();

      this.$store.dispatch(
        'businessOnboarding/SET_SELECTED_COUNTRY',
        this.formData.country
      );
      this.$store.dispatch(
        'internationalization/SET_CURRENT_COUNTRY',
        this.formData.country
      );

      this.$store.dispatch('businessOnboarding/SET_STORE_DETAILS_FORM', {
        ...this.formData,
        confirmed: true
      });

      this.$store.dispatch(
        'businessOnboarding/SET_OPERATION_TYPE',
        IBusinessType.ONLINE
      );

      this.$store.dispatch(
        'businessOnboarding/SET_SELECTED_CATEGORY',
        this.formData.category
      );

      if (APIService.token) {
        await this.onCreateBusiness();
        this.$router.push(OnlineOnboardingURL.REWARD_RATIO);
      } else {
        try {
          const { data }: any = await this.onSaveBusinessOnlineLead();
          if (data)
            this.$store.dispatch(
              'businessOnboarding/SET_BUSINESS_LEAD_ID',
              data.id
            );
        } catch (error) {
          console.error(error);
        }

        this.$router.push(OnlineOnboardingURL.USER_SIGN_UP);
      }
    } finally {
      this.loading = false;
    }
  }

  handleCloseCategory() {
    this.formData.category = {
      id: '',
      otherValue: ''
    };
  }

  async handleNotifyMe() {
    try {
      this.loading = true;

      await this.internationalizationService.reportNewIntegration({
        type: 'country',
        comment: this.formData.country.name
      });

      eventBus.$emit(
        'openSubModal',
        new ModalOptions(
          ``,
          ``,
          'none',
          true,
          ``,
          ``,
          ``,
          false,
          'newCountryNotifyModal',
          false,
          true,
          true
        ),
        {
          buttonLabel: 'Back to Twism.com',
          onConfirm: () => {
            window.location.href = 'https://www.twism.com';
          },
          onClose: () => {
            eventBus.$emit('closeModal');
            eventBus.$emit('resetSignupCountrySelect');
          },
          countryName: this.formData.country.name
        }
      );
    } finally {
      this.loading = false;
    }
  }
  initBusinessCategories(categories?: ICategory[]) {
    if (!Array.isArray(categories)) return [];

    const formatedCategories = categories.map((item: ICategory) => ({
      value: item.id,
      label: item.name
    }));

    return formatedCategories;
  }

  async getCategories() {
    return this.signUpService
      .getCategories({ version: 2 })
      .then(({ data }) => data.categories);
  }

  async initCategories() {
    const categories = this.initBusinessCategories(await this.getCategories());

    this.$store.dispatch('businessOnboarding/SET_CATEGORIES', categories);
    this.categories = categories;
  }

  created() {
    if (!this.filledCategories.length) {
      this.initCategories();
    }
  }

  mounted() {
    scrollToTop('bo-base-layout__right');
  }
}
